import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const componentState = (state: RootState) => state.component.dealListModal;

export const getLoading = createSelector(componentState, ({ loading }) => loading);
export const getDeals = createSelector(componentState, ({ deals }) => deals);
export const getTotal = createSelector(componentState, ({ total }) => total);
